import styled from "styled-components";

import { Link } from "react-router-dom";

import { Button, Table, Responsive, Form } from "semantic-ui-react";

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 10px 0;

  & > div:first-child {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  & > button {
    height: min-content !important;
    width: max-content !important;
    margin-top: 20px !important;
    min-width: max-content !important;
  }

  & > *:not(:last-child) {
    margin-right: 16px;
  }
`;

export const Content = styled.section`
  width: 80%;
  margin: 0 auto 0 auto;
  height: auto;
  padding: 51px 0 0 0;

  ${(props) =>
    props.logged &&
    `
      @media screen and (max-width: 800px) {
        padding: 2rem;
      }

      @media screen and (max-width: 600px) {
        padding: 0.5rem;
      }
  `}
`;

const MessageColor = {
  warn: "#b58105",
  error: "#db2828",
};

const Messagebackgrond = {
  warn: "#fff8db",
  error: "#ffe8e6",
};

export const Title = styled.h1`
  width: 100%;
  max-width: 1100px;

  margin: 0px auto 15px auto;
  padding-bottom: 5px;

  color: #000000;

  border-bottom: 1px solid rgba(0, 0, 0, 0.15);

  font-size: 28px;
  font-family: sans-serif;
  font-weight: 600;
`;

export const SemanticTable = styled(Table)`
  th {
    font-size: 14 !important;
    font-family: sans-serif !important;
  }

  tr {
    background: #fcfff5 !important;
    color: #2c662d !important;
    font-size: 14px;
    font-family: sans-serif;
    text-align: left;
    :hover {
      background: rgba(34, 36, 38, 0.1);
    }

    td {
      a {
        font-family: sans-serif !important;
      }
    }
  }
`;

export const Redirect = styled(Link)`
  color: #2185d0 !important;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    color: #2d8cd4 !important;
  }
`;

export const RedirectButton = styled.button`
  width: 110px;
  height: 30px;

  background: #e0e1e2;
  color: rgba(0, 0, 0, 0.6);

  font-family: sans-serif;
  font-size: 11px;
  font-weight: 600;

  border: 0px;
  border-radius: 5px;

  cursor: pointer;
  transition: all 0.5s;

  &:hover {
    background: #cacbcd;
    font-weight: 700;
  }
`;

export const TableButton = styled(Button)`
  background: none !important;
  border: none;
  i {
    color: #9999;
    :hover {
      color: ${(props) => (props.info === "edit" ? "#2185d0" : "#000")};
    }
  }
`;

export const Field = styled(Form.Field)`
  margin: 20px 0 !important;
  width: ${(props) => (props.big && "80%") || (props.small && "20%")};
`;
export const Label = styled.label`
  color: ${(props) => `${props.color}`};

  font-size: 12px;
  font-family: sans-serif;
  font-weight: 600;
`;

export const Input = styled.input`
  width: 100%;
  height: 35px;
  margin: 0;
  padding: 0.67857143em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
`;

export const SubmitButton = styled(RedirectButton)`
  background-color: #21ba45;
  color: #fff;
  text-shadow: none;
  background-image: none;
  height: 38px;
  font-size: 14px;

  &:hover {
    background: #16ab39;
  }
`;

export const WarningRed = styled(Responsive)`
  background-color: #ffe8e6 !important;
  color: #db2828;
  box-shadow: 0 0 0 1px #db2828 inset, 0 0 0 0 transparent !important;
  font-family: sans-serif;
  font-size: 14px;
`;

export const WarningYellow = styled(Responsive)`
  background-color: #fff8db !important;
  color: #b58105;
  box-shadow: 0 0 0 1px #b58105 inset, 0 0 0 0 transparent !important;
  font-family: sans-serif;
  font-size: 14px;
`;
